import { AgentConfigData, AgentInstructionOptionId } from "@jugl-web/rest-api";
import { DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION } from "@web-src/modules/cx/pages/CXAIAgentsPage/consts";

export const CUSTOM_PROMPT_ID: AgentInstructionOptionId = "custom-prompt";

const INSTRUCTION_OPTION_IDS = Object.keys(
  DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION
) as AgentInstructionOptionId[];

export const getDefaultInstructionItem = (
  optionId: AgentInstructionOptionId
): AgentConfigData["instructions"][number] => ({
  name: optionId,
  value: DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION[optionId],
});

export const normalizeInstructionItems = (
  items?: AgentConfigData["instructions"]
): AgentConfigData["instructions"] => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return [{ name: CUSTOM_PROMPT_ID, value: "" }];
  }

  const deduped = items.reduce<AgentConfigData["instructions"]>((acc, item) => {
    if (!INSTRUCTION_OPTION_IDS.includes(item.name)) return acc;
    if (acc.some((existingItem) => existingItem.name === item.name)) return acc;

    acc.push({
      name: item.name,
      value: typeof item.value === "string" ? item.value : "",
    });
    return acc;
  }, []);

  if (deduped.length === 0) {
    return [{ name: CUSTOM_PROMPT_ID, value: "" }];
  }

  return deduped;
};

export const buildInstructionsWithSelectedFirst = (
  items: AgentConfigData["instructions"] | undefined,
  optionId: AgentInstructionOptionId,
  valueOverride?: string
): AgentConfigData["instructions"] => {
  const normalized = normalizeInstructionItems(items);
  const existing = normalized.find((item) => item.name === optionId);
  const selected = existing
    ? { ...existing, value: valueOverride ?? existing.value }
    : {
        ...getDefaultInstructionItem(optionId),
        value: valueOverride ?? DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION[optionId],
      };

  return [selected, ...normalized.filter((item) => item.name !== optionId)];
};
